function initPlayAreas() {
	const block = document.querySelector('.pa-container');
	if (!block) return;

	const buttons = Array.from(block.querySelectorAll('.pa-tab-button'));
	const swipers = new Map(); // Store swiper instances by panel ID

	function initSwiper(panel) {
		if (swipers.has(panel.id)) return;

		const swiperEl = panel.querySelector('.swiper');
		const loader = panel.querySelector('.pa-swiper-loader');

		if (!swiperEl) return;

		// Small delay to ensure DOM is ready and avoid jumps
		setTimeout(() => {
			const swiperInstance = new Swiper(swiperEl, {
				slidesPerView: 1,
				spaceBetween: 20,
				loop: true,
				observer: true,
				observeParents: true,
				navigation: {
					nextEl: panel.querySelector('.swiper-button-next'),
					prevEl: panel.querySelector('.swiper-button-prev'),
				},
				on: {
					init: function () {
						if (loader) {
							loader.style.opacity = '0';
							setTimeout(() => loader.remove(), 300);
						}
					},
				},
			});

			swipers.set(panel.id, swiperInstance);
		}, 100);
	}

	function activateTab(button) {
		const panelId = button.getAttribute('aria-controls');
		const activePanel = document.getElementById(panelId);

		if (!activePanel) return;

		// Update buttons
		buttons.forEach((btn) => {
			btn.classList.remove('active');
			btn.setAttribute('aria-selected', 'false');
			btn.setAttribute('tabindex', '-1');
		});

		button.classList.add('active');
		button.setAttribute('aria-selected', 'true');
		button.setAttribute('tabindex', '0');

		// Update panels
		block.querySelectorAll('.pa-panel').forEach((panel) => {
			panel.hidden = true;
		});

		activePanel.hidden = false;

		// Lazy init swiper
		initSwiper(activePanel);
	}

	buttons.forEach((button) => {
		button.addEventListener('click', () => activateTab(button));

		button.addEventListener('keydown', (e) => {
			const index = buttons.indexOf(button);
			if (e.key === 'ArrowRight') {
				e.preventDefault();
				const nextBtn = buttons[(index + 1) % buttons.length];
				nextBtn.focus();
				activateTab(nextBtn);
			} else if (e.key === 'ArrowLeft') {
				e.preventDefault();
				const prevBtn =
					buttons[(index - 1 + buttons.length) % buttons.length];
				prevBtn.focus();
				activateTab(prevBtn);
			}
		});
	});

	// Initialize first tab's swiper if visible
	const firstActiveButton = block.querySelector('.pa-tab-button.active');
	if (firstActiveButton) {
		const firstPanelId = firstActiveButton.getAttribute('aria-controls');
		const firstPanel = document.getElementById(firstPanelId);
		if (firstPanel) {
			initSwiper(firstPanel);
		}
	}
}

document.addEventListener('DOMContentLoaded', initPlayAreas);